import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { TeamLegalCasesActions } from './partials/legal_cases'
import { TeamMemberActions } from './partials/members'
import { TeamPartyActions } from './partials/parties'
import { TeamRecordActions } from './partials/records'
import { TeamResourceActions } from './partials/resources'
import { TeamRoleActions } from './partials/roles'

export const TeamActions = {
  ...TeamLegalCasesActions,
  ...TeamMemberActions,
  ...TeamPartyActions,
  ...TeamRecordActions,
  ...TeamResourceActions,
  ...TeamRoleActions,

  getTeam: async (_, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}`).
      then(({ data }) => {
        data.config = data.config || {}
        data.config_admin = data.config_admin || {}
        return data
      }).
      catch(handleError)
  },

  getTeams: async ({ commit }) => {
    return axiosRequest.
      get('/teams').
      then(({ data }) => commit('setTeams', data)).
      catch(handleError)
  },

}
